<template>
    <div class="row team-edit-page">
        <div class="col-12 team-edit-page--top">
            <div class="team-edit-page--top-wrapper">
                <svg-image
                    :src="'/svg/' + resource_group + '/chevron-left.svg'"
                    class="mt-0"
					:spaced="true"
                    :auto_hover="true"
                    @click="back()"
                >
					<div>
						<h6 class="team-edit-page--top-name">{{user.full_name}}</h6>
						<h6 class="team-edit-page--top-email">{{user.email}}</h6>
					</div>
				</svg-image>
            </div>

            <button v-if="is_company_manager == true" class="btn btn-primary my-auto" v-on:click="editModal()">Edit</button>
        </div>

		<div class="col-12 mt-4">
			<div class="certificate-card">
				<h3 class="certificate-card--title text-capitalize">{{user.company_role_name}}</h3>
				<div class="container px-md-4 mt-2">
					<div class="row mt-3">
						<div class="col-md-4">
							<h6>First name</h6>
							<h5>{{user.first_name}}</h5>
						</div>
						<div class="col-md-4">
							<h6>Last name</h6>
							<h5>{{user.last_name}}</h5>
						</div>
						<div class="col-md-4">
							<h6>Email address</h6>
							<h5>{{user.email}}</h5>
						</div>
					</div>

					<div v-if="user.role_name === 'Operative'" class="row mt-3">
						<div class="col-md-4">
							<h6>Status</h6>
							<h5 v-bind:class="userStatus === 'Inactive' ? 'text-danger': ''">{{userStatus}}</h5>
						</div>
						<div class="col-md-4">
							<h6>Job title</h6>
							<h5>{{user.job_title ? user.job_title : '-'}}</h5>
						</div>
						<div v-if="user.subcontracted" class="col-md-4">
							<h6>Company name</h6>
							<h5>{{user.company_name ? user.company_name : '-'}}</h5>
						</div>
					</div>
				</div>
			</div>
		</div>

        <!--Training Certificates-->
        <div v-if="training_certificates.length" class="col-12 mt-4">
            <certificate-card
                title="Training Certificates"
                :certificates="training_certificates"
            ></certificate-card>
        </div>

        <!--Tool Certificates-->
        <div v-if="tool_certificates.length" class="col-12 mt-4">
            <certificate-card
                title="Tool Certificates"
                :certificates="tool_certificates"
            ></certificate-card>
        </div>

        <!--Face Fit Test Certificates-->
        <div v-if="face_fit_test_certificates.length" class="col-12 mt-4">
            <certificate-card
                title="Face Fit Test"
                :certificates="face_fit_test_certificates"
            ></certificate-card>
        </div>

		<!--PPE Equipment-->
		<div v-if="ppe_active" class="col-12 mt-4">
			<ppe-equipment-card
				:ppe_registers="user.ppe_registers"
			></ppe-equipment-card>
		</div>

        <edit-staff-modal
			:edit_user = true
			title= 'Edit'
			@parent_method="reloadPage"
			:company_roles = company_roles
			:roles="roles"
            :user_data="user"
            :url="update_url"
			:extra_stuff="user.role_name === 'Operative'"
            ref="edit_modal"
        ></edit-staff-modal>
    </div>
</template>

<script>
	import Modal from "../general_components/Modal";
    import EditStaffModal from "../modals/EditStaffModal";
    import GalleryViewComponent from "../general_components/GalleryViewComponent";
    import CertificateCard from "../people/CertificateCard";
	import PpeEquipmentCard from "../people/PpeEquipmentCard";
	export default {
		name: "EditPeoplePage",
		components: {PpeEquipmentCard, CertificateCard, GalleryViewComponent, EditStaffModal, Modal},
		props: [
			'user',
			'roles',
            'update_url',
			'ppe_active',
            'back_url',
			'company_roles',
			'is_company_manager'
        ],

        data(){
			return {
				user_edit: null,
				certificate: null,
                document_selected: 0,
                document_length: 0
            }
        },

        beforeMount() {
			this.user_edit = Object.assign({}, this.user);
		},

        methods: {
			reloadPage(){
				window.location.reload();
			},
            editModal(){
			    this.$refs.edit_modal.openModal();
            },
            back(){
                // if (this.back_url) window.location.href = this.back_url;
                window.history.back()
            }
        },

        computed:{
			training_certificates(){
				let certificates = [];
				this.user.certificates.forEach(function (certificate){
					if (certificate.type === 'training'){
						certificates.push(certificate);
					}
                });

				return certificates;
            },
			tool_certificates(){
				let certificates = [];
				this.user.certificates.forEach(function (certificate){
					if (certificate.type === 'tool'){
						certificates.push(certificate);
					}
                });

				return certificates;
            },
			face_fit_test_certificates(){
				let certificates = [];
				this.user.certificates.forEach(function (certificate){
					if (certificate.type === 'face_fit_test'){
						certificates.push(certificate);
					}
                });

				return certificates;
            },
			userStatus(){
				if (this.user.inactive_at)
					return 'Inactive';
				return this.user.subcontracted ? 'Subcontracted' : 'Employed';
			}
        },
	}
</script>
